// extracted by mini-css-extract-plugin
export var centerText = "_dd-8";
export var container = "_dd-0";
export var doughnutContainer = "_dd-7";
export var legend = "_dd-a";
export var legendItemColorDisplay = "_dd-b";
export var legendItemLabel = "_dd-d";
export var legendItemValue = "_dd-c";
export var lg = "_dd-5";
export var maxWidth = "_dd-9";
export var md = "_dd-4";
export var responsive = "_dd-6";
export var sm = "_dd-3";
export var xs = "_dd-2";
export var xxs = "_dd-1";